import React from 'react';

import { useColorThemeContext } from '@app/core/contexts/colorTheme/ColorThemeContext';
import { useTranslation } from '@app/core/i18n';

export enum AppStoreType {
  AppleAppStore = 'app-store',
  AndroidPlayMarket = 'google-play',
}

export interface AppStoreIconLinkProps {
  readonly appStoreType: AppStoreType;
  readonly altBefore?: string;
}

export const AppStoreIconLink: React.FC<AppStoreIconLinkProps> = ({
  appStoreType,
  altBefore,
}) => {
  const { t } = useTranslation();

  const { colorTheme } = useColorThemeContext();
  const linkUrl = appStoreType === AppStoreType.AppleAppStore
    ? t('app-store.app-store.link.url|App store Apple Store link url', 'https://www.apple.com/app-store/')
    : t('app-store.google-play.link.url|App store Google Play link url', 'https://play.google.com/store/apps/');

  const imagePath = `img/app-stores/${colorTheme}-${appStoreType}-badge.svg`;
  // publicPath is not visible to IDE here, but it should be used to load image correctly in env
  // @ts-ignore
  const imgLink = `${window.publicPath}${imagePath}`;

  const alt = (altBefore || '')
    + (appStoreType === AppStoreType.AppleAppStore
      ? t('app-store.app-store.image.alt|App store Apple Store image alt', 'Link to Apple app store')
      : t('app-store.google-play.image.alt|App store Google Play image alt', 'Link to Google Play'));

  return (
    <a href={linkUrl}>
      <img src={imgLink} alt={alt} width="134" height="40" />
    </a>
  );
};
